<template>
  <div class="login">
    <div class="share-box">
      <span class="share_text">{{type === 'KEE'? '分享KEE 邀请小伙伴一起夯实测量基础':'分享KTS 邀请小伙伴一起夯实测量基础'}}</span>
      <button v-if="IsPC" class="share-btn" @click="copyLink"><img src="../assets/copy.png" alt="">&nbsp;复制链接</button>
      <button v-if="!IsPC" class="share-btn" @click="copyLinkWap" :data-clipboard-text="'https://kee.smarket.net.cn/2019/index.html?industryType='+ urlParam.industryType+ '&year=' +urlParam.year+
      '&showType=' +urlParam.showType + '&type=' + type + '&ARC=' + ARC">
        <img src="../assets/copy.png" alt="Copy to clipboard">&nbsp;复制链接
      </button>
    </div>
    <div class="login-before-box" v-if="!isLogin">
      <span class="tip">*</span>
      <input type="text" v-if="IsPC" v-validate="'required|loginName'" name="loginName" placeholder="中国大陆手机号或邮箱登陆/其他地区邮箱登陆"
             v-model="login_name" @input="loginFocus" @keyup.enter="doLogin"/>
      <input type="text" v-if="!IsPC" v-validate="'required|loginName'" name="loginName" placeholder="中国大陆手机号或邮箱登陆/其他地区邮箱登陆"
             v-model="login_name" @input="loginFocus" @keyup.enter="doLogin"/>
      <div class="error-text">{{ errors.first('loginName') }}</div>
      <div class="error-text" v-show="noRegShow">{{ noRegText }}</div>
      <button class="login-btn" @click="doLogin">登录</button>
      <div class="tapRegister">没有账号，<a @click="goRegister">立即注册</a></div>
    </div>
    <div class="login-after-box" v-if="isLogin && IsPC">
      <div class="hello-msg-box">
        <span>欢迎您，</span>
        <span>{{name}}</span>
      </div>
      <a @click="doLogout">退出</a>
    </div>
    <!-- 复制文字的input -->
    <input type="text" id="copy-input">
  </div>
</template>

<script>
  import bus from '../utils/eventBus';
  import {setCookie, getCookie, removeCookie} from '../utils/public';
  import Clipboard  from 'clipboard';
  import VueCookies from 'vue-cookies'
  export default {
    name: 'Login',
    data() {
      return {
        registerBoxShow: false,
        login_name: '',
        contentId: '',
        isLogin: false,
        errText: '',
        name: '',
        noRegShow: false,
        noRegText: '输入的手机或者邮箱未注册，请先注册',
        IsPC: false,
        registerUrl:'',
        increaseUrl:'https://kee.smarket.net.cn/register/index.html#/updateUser?type=' + this.type,
        ARC: smarket.urlParams.ARC?smarket.urlParams.ARC:'',
      };
    },
    props: ['screenWidth'],
    computed: {
      loginStatus() {
        return this.$store.state.loginStatus;
      },
      urlParam() {
        return this.$store.state.urlParam;
      },
      type(){
        return this.$store.state.type;
      },
    },
    watch: {
      loginStatus: function(val, oVal) {
        if (val == 1) {
          this.isLogin = true;
          this.name = this.$store.state.info.firstName + this.$store.state.info.lastName;
        } else {
          this.isLogin = false;
        }
      },
      screenWidth: function(val, oVal) {
        if (val > 750) {
          this.IsPC = true;
        } else {
          this.IsPC = false;
        }
      },
    },
    created() {
      var _self = this;
      this.getid();

      if (getCookie('username') == 'undefined' || getCookie('username') == '' || !getCookie('username')) {
        //console.log(1);
      } else {
        _self.getUserMsg();
      }
    },
    mounted() {
      // this.$store.commit('setIsLoading', 'hide')
      if (this.screenWidth > 750) {
        this.IsPC = true;
      } else {
        this.IsPC = false;
      }
      if(!smarket.urlParams.ARC){
          this.registerUrl='https://kee.smarket.net.cn/register/index.html#/register?type=' + this.type;
      }else{
        this.registerUrl='https://kee.smarket.net.cn/register/index.html#/register?ARC=' + this.ARC + '&type=' + this.type;
      }
      // textField.placeholder = @"username is in here!";
      // [textField setValue:[UIColor redColor] forKeyPath:@"_placeholderLabel.textColor"];
      // [textField setValue:[UIFont boldSystemFontOfSize:16] forKeyPath:@"_placeholderLabel.font"];
    },
    methods: {
      goRegister: function() {
          debugger
        // bus.$emit('registerBoxShow', true);
        // this.$store.commit('setIsRegistering', 1);
          if(!smarket.urlParams.ARC){
              this.registerUrl='https://kee.smarket.net.cn/register/index.html#/register?type=' + this.type;
          }else{
              this.registerUrl='https://kee.smarket.net.cn/register/index.html#/register?ARC=' + this.ARC + '&type=' + this.type;
          }
        window.location.href = this.registerUrl;
      },
      copyLink: function() {
        var input = document.getElementById('copy-input');
        input.value = `https://kee.smarket.net.cn/2019/index.html?industryType=${this.urlParam.industryType}&year=${this.urlParam.year}&showType=${this.urlParam.showType}&type=${this.type}&ARC=${this.ARC}`; // 复制的内容
        input.select(); // 选中文本
        document.execCommand('copy'); // 执行浏览器复制命令
        input.blur();
        console.log('复制成功');
        console.log(input.value);
        bus.$emit('showToast', '复制成功');
        // $.Huimodalalert('复制成功',2000);
      },
      copyLinkWap: function(){
        var clipboard = new Clipboard('.share-btn');
        clipboard.on('success', function(e) {
          console.log(e)
          bus.$emit('showToast', '复制成功');
          e.clearSelection();
        });

        clipboard.on('error', function(e) {
          bus.$emit('showToast', '复制失败');
        });
      },
      loginFocus: function() {
        this.noRegShow = false;
      },
      doLogin: function() {
        this.$validator.validate('loginName').then(result => {
          if (result) {
            // do stuff if not valid.
            var _self = this;
            $.ajax({
              url: window.config.api.gateway.general + '/member/login',
              type: 'post',
              dataType: 'json',
              data: {
                'tenantId': window.config.tenantId,
                'schemaId': window.config.schemaId,
                'memberFormId': window.config.formId,
                'memberSchemaId': window.config.schemaId,
                'unique': _self.login_name,
                'token': '',
                'password': '96E79218965EB72C92A549DD5A330112',
                'checkCode': '',
                'loginType': '',
                'globalUserId': _self.contentId
              },
              success: function(e) {
                // console.log(e);
                if (e.body.desc == 'successful') {
                  setCookie('globalUserId', e.body.content.session, 7);
                  let formDataKey=window.config.formDataKey;
                  let data = e.body;
                  let formData = [];
                    if (data['content'] && data['content']['info']) {
                        formDataKey.forEach(function (key) {
                            var obj = {
                                'fieldName': key,
                                'value': data['content']['info'][key]
                            };
                            formData.push(obj);
                        });
                    }
                    debugger
                  smarket.cookie.smarketMember(window.config.schemaId, {
                    session: e.body.content.session,
                    memberId: e.body.content.memberModel.memberId,
                      formData:formData,
                      name:data['content']['info']['name'] || '',
                      registerTime:data['content']['memberModel']['createTime'] || ''
                  }, {expires: 7});
                  setCookie('sess', e.body.content.sess, 7);
                  VueCookies.set("isKeeAutoLogin",_self.login_name)
                  setCookie('username', e.body.content.memberModel.unique, 7);
                  if (!e.body.content.memberModel.hasOwnProperty('isKEE') || !e.body.content.memberModel.isKEE) {
                    $.ajax({ //更新字段
                      url: window.config.api.gateway.general + '/api/member/contacts/info/update',
                      type: 'post',
                      dataType: 'json',
                      data: {
                        'memberFormId': window.config.formId,
                        'sess': e.body.content.sess,
                        'formData': [{fieldName: 'isKEE', value: '是'}]
                      },
                      success: function(e) {

                      }
                    });
                  }
                  let requiredUpdate = false;
                  const requiredField = window.config.requiredField;
                  requiredField.forEach( item => {
                    if(!e.body.content.memberModel[item] && !requiredUpdate) {
                      requiredUpdate = true;
                    }
                  })
                  //是否跳转信息补全页
                    let isSignUpFlag=false;
                    $.ajax({ //更新字段
                        url: window.config.api.gateway.general + '/api/webinar/contacts/login',
                        type: 'post',
                        async:false,
                        dataType: 'json',
                        data: {
                            "webinarId":"38379",
                            'tenantId': window.config.tenantId,
                            'value':_self.login_name,
                            'sess': e.body.content.sess,
                        },
                        success: function(signUpData) {
                            if(signUpData.body.result==0){
                                isSignUpFlag=signUpData.body.content.isSignUp == 1 ? true : false;
                            }
                        }
                    });
                  if(requiredUpdate&&!isSignUpFlag){
                      // _self.$store.commit('setIsRegistering', 2);
                      // _self.$store.commit('setUserInfo', e.body.content.memberModel);
                    window.location.href = _self.increaseUrl;
                  }else{
                      _self.login_name = '';
                      _self.$store.commit('setLoginStatus', 1);
                      _self.$store.commit('setUserInfo', e.body.content.memberModel);
                      bus.$emit('showToast', '登录成功');
                      // $.Huimodalalert('登录成功',2000);
                  }
                } else {
                  _self.noRegShow = true;
                }

              }
            });
          }
        });

      },
      doLogout: function() {
        removeCookie('sess');
        removeCookie('globalUserId');
        removeCookie('smarketMember_' + window.config.schemaId);
        removeCookie('username');
        VueCookies.set("isKeeAutoLogin",'');
        this.$store.commit('setLoginStatus', 0);
        this.$store.commit('setUserInfo', {});
        this.login_name = '';
        // $('.Hui-iconfont-xuanze').removeClass('active');
        // $.Huimodalalert('退出成功',2000);
      },
      getid: function() {
        var _self = this;
        var smarket = {};
        (function(smarket, $) {
          if (!smarket) {
            throw new Error('Require the smarket module.');
          }
          var client = smarket.client = smarket.client || {
            ip: '',
            browser: {
              version: '',
              name: ''
            },
            os: {
              name: ''
            },
            screen: {
              width: window.screen.width,
              height: window.screen.height,
              resolution: window.screen.width + ' * ' + window.screen.height
            }
          };

          if ($.ua) {
            client.browser.version = $.ua.browser.version,
              client.browser.name = $.ua.browser.name,
              client.os.name = $.ua.os.name;
          }

          $.getScript('//pv.sohu.com/cityjson?ie=utf-8').done(function() {
            client.ip = returnCitySN.cip;
          });
        })(smarket, $);
        $.ajax({
          url: window.config.api.gateway.general + '/anonymous/getId',
          type: 'post',
          dataType: 'json',
          data: {
            clientVersion: smarket.client.browser.version,
            clientBrand: smarket.client.browser.name,
            clientType: smarket.client.os.name,
            clientIP: smarket.client.ip
          },
          success: function(e) {
            _self.contentId = e.body.content;
            _self.$store.commit('setContentId', _self.contentId);
          }
        });
      },
      getUserMsg: function() {//根据cookie获取用户信息
        var _self = this;
        $.ajax({//自动登陆
          url: window.config.api.gateway.general + '/member/login',
          type: 'post',
          dataType: 'json',
          data: {
            'tenantId': window.config.tenantId,
            'schemaId': window.config.schemaId,
            'memberFormId': window.config.formId,
            'memberSchemaId': window.config.schemaId,
            'unique': getCookie('username'),
            'token': '',
            'password': '96E79218965EB72C92A549DD5A330112',
            'checkCode': '',
            'loginType': '',
            'globalUserId': _self.contentId
          },
          success: function(e) {
            if (e.body.desc == 'successful') {
              setCookie('globalUserId', e.body.content.session, 7);
              smarket.cookie.smarketMember(window.config.schemaId, {
                session: e.body.content.session,
                memberId: e.body.content.memberModel.memberId
              }, {expires: 7});
              setCookie('sess', e.body.content.sess, 7);
              setCookie('username', e.body.content.memberModel.unique, 7);
              if(e.body.content.status=="increase"){
                  _self.$store.commit('setLoginStatus', 0);
              }else{
                  _self.$store.commit('setLoginStatus', 1);
              }
              _self.$store.commit('setUserInfo', e.body.content.memberModel);
              // bus.$emit('showToast', "登录成功");
            }
          }
        });
      },
    }
  };
</script>

<style lang="scss" scoped>
  @media (min-width: 750px) {
    .login {
      .share-box {
        padding-left: 88px;
        height: 60px;
        line-height: 60px;
        font-size: 15px;
        border: 1px solid #eeeeee;
        background: url("../assets/share-bg.png") no-repeat;

        .share_text {
          display: inline-block;
          height: 25px;
          line-height: 25px;
          vertical-align: middle;
          color: $color;
        }

        .share-btn {
          margin-left: 35px;
          color: $shareRed;
          width: 110px;
          height: 25px;
          font-size: 13px;
          font-weight: bold;
          display: inline-block;
          border: 1px solid $shareRed;
          border-radius: 20px;
          background: $shareBg;
          vertical-align: middle;
          outline: none;
          cursor: pointer;
        }
      }

      .login-before-box {
        margin-top: 8px;
        padding: 25px 36px;
        text-align: center;
        border-top: 2px solid $commonRed;
        background: $loginbg;

        .tip {
          color: $commonRed;
          margin-right: 8px;
        }
        .error-text {
          text-align: left;
          color: $commonRed;
          margin-left: 30px;
          margin-top: 10px;
        }
        input {
          width: 460px;
          height: 38px;
          text-indent: 12px;
          border: 1px solid #dddddd;
          outline: none;
        }
        input::-ms-clear{display:none;}
        .login-btn {
          display: block;
          width: 160px;
          height: 36px;
          color: #fff;
          background-color: $commonRed;
          border: none;
          font-size: 15px;
          margin: 13px auto;
          cursor: pointer;
          outline: none;
        }

        .tapRegister {
          color: $color;
          font-size: 13px;
          a {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }

      .login-after-box {
        margin-top: 8px;
        padding: 40px 0;
        text-align: center;
        border-top: 2px solid $commonRed;
        background: $loginbg;

        .hello-msg-box {
          font-size: 24px;
          font-weight: bold;
          color: $commonRed;
          padding-bottom: 15px;
        }

        a {
          font-size: 13px;
          cursor: pointer;
          text-decoration: underline;
        }
      }
      #copy-input {
        position: absolute;
        top: -100px;
        left: -100px;
      }
    }
  }

  @media (max-width: 750px) {
    .login {
      width: 100%;
      .share-box {
        margin: 0 pxToRem(28);
        height: pxToRem(90);
        line-height: pxToRem(90);
        border: 1px solid #eeeeee;
        background: url("../assets/share-bg.png") no-repeat;
        background-size: 100% 100%;
        text-align: center;

        .share_text {
          display: inline-block;
          height: pxToRem(35);
          font-size: pxToRem(22);
          color: $color;
        }

        .share-btn {
          position: relative;
          img {
            position: absolute;
            width: pxToRem(15);
            left: pxToRem(20);
            top: pxToRem(8);
          }
          margin-left: pxToRem(35);
          color: $shareRed;
          height: pxToRem(35);
          line-height: pxToRem(34);
          width: pxToRem(155);
          box-sizing: border-box;
          font-size: pxToRem(18);
          font-weight: bold;
          display: inline-block;
          border: 1px solid $shareRed;
          border-radius: pxToRem(20);
          background: $shareBg;
          vertical-align: middle;
          outline: none;
          cursor: pointer;
          padding-left: pxToRem(25);
        }
      }

      .login-before-box {
        margin: 0 4%;
        margin-top: pxToRem(40);
        padding: pxToRem(68) pxToRem(0) pxToRem(38);
        text-align: center;
        border-top: 2px solid $commonRed;
        background: $loginbg;

        .tip {
          color: $commonRed;
          margin-right: pxToRem(8);
          font-size: pxToRem(28);
          vertical-align: middle;
        }
        .error-text {
          text-align: left;
          color: $commonRed;
          margin-left: pxToRem(80);
          margin-top: pxToRem(10);
          font-size: pxToRem(24);
        }
        input {
          width: 88%;
          font-size: pxToRem(24);
          padding: pxToRem(24) 0;
          height: pxToRem(66);
          text-indent: pxToRem(18);
          border: 1px solid #dddddd;
          vertical-align: middle;
          outline: none;
          color: #524f56;
          -webkit-appearance: none;
          border-radius: pxToRem(0);
          box-sizing: border-box;
        }

        .login-btn {
          display: block;
          width: pxToRem(290);
          height: pxToRem(70);
          color: #fff;
          background-color: $commonRed;
          border: none;
          font-size: pxToRem(24);
          border-radius: 3px;
          margin: pxToRem(35) auto pxToRem(20);
          cursor: pointer;
          outline: none;
          border-radius: pxToRem(0);
        }

        .tapRegister {
          color: $color;
          font-size: pxToRem(22);
          a {
            cursor: pointer;
            text-decoration: none;
            border-bottom: 1px solid #666666;
          }
        }
      }

      .login-after-box {
        margin: 0 4%;
        margin-top: pxToRem(40);
        padding: pxToRem(68) pxToRem(28) pxToRem(38);
        text-align: center;
        border-top: 2px solid $commonRed;
        background: $loginbg;

        .hello-msg-box {
          font-size: pxToRem(34);
          padding-bottom: pxToRem(30);
          font-weight: bold;
          color: $commonRed;
        }

        a {
          font-size: pxToRem(24);
          color: $color;
          cursor: pointer;
          text-decoration: underline;
        }
      }
      #copy-input {
        position: absolute;
        top: pxToRem(-100);
        left: pxToRem(-100);
      }
    }
  }
</style>
